import { Carrier } from '@/data/mobile/carrier';
import { CarrierId } from '@/@types/carrierId';
import { SimTypeId } from '@/@types/simTypeId';

export class Option {
  public id: string;
  public name: string;
  public charge: number;
  public groupId: string;
  public simIds: SimTypeId[];
  public carriers: Carrier[];

  constructor(
    id: string,
    name: string,
    charge: number,
    groupId: string,
    simIds: SimTypeId[],
    carriers: Carrier[]
  ) {
    this.id = id;
    this.name = name;
    this.charge = charge;
    this.groupId = groupId;
    this.simIds = simIds;
    this.carriers = carriers;
  }

  public canUse(carrier: CarrierId): boolean {
    const list = this.carriers.map(c => {
      return c.id;
    });
    return list.includes(carrier);
  }

  // 通話パックは60分と90分を同時に申し込むことはできない
  public isDuplicateNotPossible(): boolean {
    return this.groupId == 'call_pack';
  }
}
